import React from 'react';
import classnames from 'classnames';
import { DealerReviewsLoading } from 'site-modules/dealerships/components/dealer-reviews-section/components/dealer-reviews-loading/dealer-reviews-loading';
import PropTypes from 'prop-types';

export function WithLoading({ children, isLoading }) {
  return (
    <>
      {isLoading && <DealerReviewsLoading />}
      <div className={classnames({ 'd-none': isLoading })}>{children}</div>
    </>
  );
}

WithLoading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
